<template>
  <div id="verify-email-form">
    <p class="enter-code-notice">{{ $t('enterCodeNotice') }}</p>
    <div class="form-group">
      <label for="verificationCode">{{ $t('placeholder.yourCode') }}</label>
      <input 
        autocomplete="off" 
        type="text" 
        id="verificationCode"
        v-model="verificationCode"
        :placeholder="$t('placeholder.yourCode')"
        name="verificationCode"
        v-validate="'required|numeric|digits: 5'"
        :class="{'danger-border': showError && codeError}"
        @keyup.enter="bindingEmail"
        @blur="showError = true"
        @focus="showError = false">
      <p class="error-info">
        <span v-show="showError && errors.has('verificationCode')">{{ errors.first('verificationCode') }}</span>
        <span v-show="showError">{{ errorMsg }}</span>
      </p>
      <p class="not-received">
        <template v-if="countDown > 0"><span>{{ $t('sent') }}{{ countDown }}{{ $t('seconds') }}</span></template>
        <template v-else><span class="resend" @click="sendVerificationCodeToEmail">{{ $t('resend') }}</span></template>
      </p>
    </div>
    <spinner :show="loading" class="spinner-component"></spinner>
    <button class="form-submit" @click="bindingEmail" v-if="!loading">{{ $t('submit') }}</button>
  </div>
</template>

<script>
  import locales from './lang'
  import Spinner from '../../components/Spinner.vue'

  export default {
    name: 'verify-email-form',
    locales,
    components: {Spinner},
    data: function () {
      return {
        verificationCode: '',
        showError: false,
        errorMsg: '',
        countDown: 60,
        loading: false
      }
    },
    computed: {
      codeError() {
        return this.errors.has('verificationCode') || !!this.errorMsg
      },
      email() {
        return this.$store.state.user.email
      }
    },
    watch: {
      verificationCode() {
        this.showError = false
        this.errorMsg = ''
      }
    },
    mounted() {
      this.runTimer()
    },
    beforeDestroy() {
      this.$store.commit('setShowVerifyForm', false)
    },
    methods: {
      bindingEmail() {
        this.showError = true
        this.loading = true
        this.$validator.validateAll({verificationCode: this.verificationCode}).then(success => {
          if (!success) {
            this.loading = false
            return
          }
          this.$http.patch('api/email/binding', {
            email: this.email,
            verification_code: this.verificationCode
          }).then((response) => {
            this.loading = false
            if (response.data.code === 0) {
              this.$store.commit('setShowVerifyForm', false)
              this.$store.commit('setShowVerifySuccess', true)
            } else {
              this.errorMsg = response.data.message
            }
          })
        })
      },
      sendVerificationCodeToEmail() {
        this.$http.post('api/verification/email', {
          email: this.email,
          type: 'binding'
        }).then((response) => {
          if (response.data.code === 0) {
            this.countDown = 60
            this.runTimer()
          }
        })
      },
      runTimer: function () {
        if (this.countDown > 0) {
          this.countDown--
          setTimeout(this.runTimer, 1000)
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";

  #verify-email-form {
    font-size: .24rem;
    color: #333;
    letter-spacing: 0.82px;
    line-height: .28rem;
    .enter-code-notice {
      font-weight: 600;
      padding-bottom: .4rem;
    }
    .not-received {
      display: inline;
      position: absolute;
      right: 16px;
      top: 50px;
      span {
        font-size: 16px;
        line-height: 24px;
        color: #999999;
        &.resend {
          cursor: pointer;
          color: #295FFD;
        }
      }
    }
  }

  div.form-group {
    text-align: left;
    input {
      margin-top: .08rem;
      height: .54rem;
      line-height: .54rem;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      padding: 0 24px;
      font-size: 16px;
      &::placeholder {
        color: #ccc;
      }
    }
  }
  
  .form-submit {
    margin: .16rem 0 0;
    height: 54px;
    line-height: 54px;
    font-size: 18px;
    font-weight: 600;
    background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
    border-radius: 42px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      border-radius: 42px;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      -moz-filter: blur(4px);
      -ms-filter: blur(4px);
      -o-filter: blur(4px);
      z-index: -1;
    }
  }

  @mixin pc-style() {
    #verify-email-form {
      width: 100%;
      max-width: 4rem;
      margin: 0 auto;
    }
  }

  @mixin phone-style() {
    #verify-email-form {
      .not-received {
        top: 45px;
      }
    }

    div.form-group {
      input {
        height: 0.49rem;
        line-height: .49rem;
        font-size: 14px;
        padding: 0 16px;
      }
    }
    .form-submit {
      margin-top: .24rem;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
    }
  }

  @media (min-width: 768px) {
    @include pc-style()
  }

  @media (max-width: 767px) {
    @include phone-style()
  }

  @media (max-width: 374px) {
    #verify-email-form .not-received {
      top: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// VerifyEmailForm.vue?7ea217bd